<template>
  <component :is="buttonComponent" v-bind="$attrs" />
</template>

<script setup lang="ts">
  interface Props {
    type: 'base' | 'vendor' | 'researcher';
  }

  const props = defineProps<Props>();

  const buttonComponent = computed(() => {
    switch (props.type) {
      case 'vendor':
        return defineAsyncComponent(
          () => import('@/components/LogoutButton/LogoutButton.vue')
        );
      case 'researcher':
        return defineAsyncComponent(
          () => import('@/components/NewReportButton/NewReportButton.vue')
        );
      default:
        return defineAsyncComponent(
          () => import('@/components/StartFreeButton/StartFreeButton.vue')
        );
    }
  });
</script>
